import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles/index";
import InfiniteScroll from "react-infinite-scroller";
import { CircularProgress, Typography } from "material-ui";

const styleSheet = theme => ({
    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`
    },
    scrollContainer: {
        margin: `${2 * theme.spacing.unit}px 0`
    },
    itemContainer: {
        margin: `${2 * theme.spacing.unit}px 0`
    },
    "@media (min-width: 600px)": {
        scrollContainer: {
            margin: theme.spacing.unit * 2
        }
    },
    emptyState: {
        margin: 2 * theme.spacing.unit
    },
    loadingContainer: {
        width: "100%",
        textAlign: "center"
    }
});

class ComponentScroll extends Component {
    static propTypes = {
        hasMore: PropTypes.bool.isRequired,
        edges: PropTypes.object.isRequired,
        loadMore: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        renderComponent: PropTypes.func.isRequired,
        emptyStateMessage: PropTypes.string.isRequired
    };

    render() {
        const {
            classes,
            edges,
            renderComponent,
            loadMore,
            hasMore,
            emptyStateMessage
        } = this.props;

        const items = edges.map(({ node }, i) => {
            return (
                <div key={node.id} className={classes.itemContainer}>
                    {renderComponent(node)}
                </div>
            );
        });

        let emptyState;
        if (items.count() === 0 && !hasMore) {
            emptyState = (
                <Typography className={classes.emptyState} type="body1">
                    {emptyStateMessage}
                </Typography>
            );
        }

        return (
            <InfiniteScroll
                pageStart={0}
                loadMore={loadMore}
                hasMore={hasMore}
                loader={
                    <div className={classes.loadingContainer}>
                        <CircularProgress className={classes.progress} />
                    </div>
                }>
                <div className={classes.scrollContainer}>
                    {items}
                    {emptyState}
                </div>
            </InfiniteScroll>
        );
    }
}

export default withStyles(styleSheet)(ComponentScroll);



// WEBPACK FOOTER //
// ./src/components/ComponentScroll.jsx